/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import clsx from "clsx";
import React from "react";
import {useTranslation} from "react-i18next";
import BookingLoginReservationDetailButtonInner
    from "pages/Front/Booking/BookingLogin/components/BookingLoginReservationDetail/components/BookingLoginReservationDetailButtonInner";

interface BookingLoginReservationDetailButtonProps {
    className?: string;
    onClick: (val: any) => void;
    children: React.ReactNode | React.ReactNode[];
    type?: "button" | "reset" | "submit" | undefined;
    isLoading?: boolean;
    disabled?: boolean;
}

const BookingLoginReservationDetailButton = (props: BookingLoginReservationDetailButtonProps) => {
    const {t} = useTranslation();
    return (
        <button
            className={clsx("BookingLoginReservationDetailButton group disabled:cursor-not-allowed", props.disabled ? "cursor-not-allowed" : "cursor-pointer")}
            disabled={props.disabled}
            type={props.type || "button"}
            onClick={props.onClick}
        >
            <BookingLoginReservationDetailButtonInner className={props.className} disabled={props.disabled} isLoading={props.isLoading}>
                {props.children}
            </BookingLoginReservationDetailButtonInner>
        </button>
    );
};

export default BookingLoginReservationDetailButton;
